
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"63","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 26.367V0h21.346v5.731H5.77v20.636H0z","fill":"#A7B241"}}),_c('path',{attrs:{"d":"M21.434 12.084v8.106l.085.083v-8.107l-.085-.082z","fill":"#fff"}}),_c('path',{attrs:{"d":"M19.657 10.318h-9.274v5.731h6.885l4.25 4.224v-8.107l-1.861-1.848z","fill":"#A7B241"}}),_c('path',{attrs:{"d":"M50.814 5.731h12.073V0H49.3v7.236c.786-.778 1.324-1.315 1.515-1.505z","fill":"#B5BDCE"}}),_c('path',{attrs:{"d":"M41.138 7.239v8.106l8.16-8.109V0h-.873l-7.287 7.239z","fill":"#5A6E91"}}),_c('path',{attrs:{"d":"M37.335 11.015v8.106l3.803-3.775V7.239l-3.803 3.776z","fill":"#7885A4"}}),_c('path',{attrs:{"d":"M28.847 19.446l-7.328-7.28v8.107l7.328 7.282 8.489-8.434v-8.106l-8.49 8.43z","fill":"#3A547C"}}),_c('path',{attrs:{"d":"M62.887 26.367v-16.05H51.924v5.732h5.192v4.587H49.3v5.731h13.588z","fill":"#B5BDCE"}}),_c('path',{attrs:{"d":"M49.299 20.636h-8.046v5.731H49.3v-5.731z","fill":"#5A6E91"}})])
          )
        }
      }
    